import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ProjectService } from '../../../../services/ProjectService';
import { toast } from 'react-toastify';
import { IoIosFolder } from 'react-icons/io';
import { FaCheck, FaRegEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";

export default function AdminFolder() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);
  const [folderName, setFolderName] = useState("");
  const [loading, setLoading] = useState(false);

  const [editingFolderId, setEditingFolderId] = useState(null);
  const [editName, setEditName] = useState("");

  const fetchFolders = async () => {
    try {
      const result = await ProjectService.getProjectFolders(id);
      if (result) setFolders(result);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    fetchFolders();
  }, [id]);

  const createFolder = async () => {
    if (!folderName.trim()) return;

    try {
      setLoading(true);
      const finalData = {
        projectId: id,
        name: folderName,
      };
      const result = await ProjectService.createNewProjectFolder(finalData);
      if (result) {
        toast.success("Folder created");
        setFolderName("");
        await fetchFolders(); 
      } else {
        toast.error("Failed to create folder");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create folder");
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (folder) => {
    setEditingFolderId(folder.id);
    setEditName(folder.name);
  };

  const cancelEdit = () => {
    setEditingFolderId(null);
    setEditName("");
  };

  const saveEdit = async (folderId) => {
    if (!editName.trim()) {
      toast.error("Folder name cannot be empty");
      return;
    }
    try {
      setLoading(true);
      const finalData = {
        projectId: id,
        name: editName,
      };
      const result = await ProjectService.editNewProjectFolder(finalData, editingFolderId);
      if (result) {
        setFolders((prev) =>
          prev.map((f) =>
            f.id === folderId ? { ...f, name: editName } : f
          )
        );
        toast.success("Folder name updated");
        cancelEdit();
      } else {
        toast.error("Failed to update folder name");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update folder name");
    } finally {
      setLoading(false);
    }
  };

  const isDocOrResearch = (name) => {
    const lower = name.toLowerCase();
    return lower.includes("documentation") || lower.includes("research_paper");
  };

  return (
    <div className="p-6">

{/* Mobile-friendly input + button */}
<div className="mb-6 w-full">
  <div className="flex flex-col sm:flex-row gap-3 w-full">
    <input
      type="text"
      placeholder="Folder name"
      value={folderName}
      onChange={(e) => setFolderName(e.target.value)}
      className="border px-3 py-2 rounded w-full sm:w-64 text-sm sm:text-base"
    />

    <button
      onClick={createFolder}
      disabled={loading}
      className="bg-blue-600 text-white rounded disabled:opacity-50 px-4 py-2 w-full sm:w-auto text-sm sm:text-base flex items-center justify-center gap-2"
    >
      {loading ? "Creating..." : "+ Create Folder"}
    </button>
  </div>
</div>


      {/* Folder grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {folders.map((folder) => (
          <div
            key={folder.id}
            onClick={() => {
              if (isDocOrResearch(folder.name)) {
                navigate(`/view-project/${id}/emp-doc-subfolder/${folder.id}`);
              } else {
                navigate(`/view-project/emp-doc/documents/${id}/${folder.id}/0`);
              }
            }}
            className="border rounded-lg p-3 hover:shadow-md cursor-pointer"
          >
            <div className="flex flex-col items-center gap-3">
              <div className="h-24 w-24">
                <IoIosFolder className="w-full h-full text-[#F4B400]" />
              </div>
              <div className="w-full text-center">
                {editingFolderId === folder.id ? (
                  <div className="flex items-center gap-2 justify-center">
                    <input
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                      className="border px-2 py-1 text-sm rounded w-32"
                      autoFocus
                      onClick={(e) => e.stopPropagation()}
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        saveEdit(folder.id);
                      }}
                      className="text-green-600 text-sm"
                    >
                      <FaCheck className='text-md lg:text-lg'/>
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        cancelEdit();
                      }}
                      className="text-red-600 text-sm"
                    >
                      <ImCross className='text-sm lg:text-lg' />
                    </button>
                  </div>
                ) : (
                  <div className="flex items-center justify-center gap-4">
                    <span className="break-words line-clamp-2">
                      {folder.name}
                    </span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        startEdit(folder);
                      }}
                      className="text-blue-500 hover:text-blue-700 text-sm md:text-md lg:text-lg xl:text-xl"
                    >
                      <FaRegEdit />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}

        {folders.length === 0 && (
          <p className="col-span-full text-center text-gray-500">
            No folders found
          </p>
        )}
      </div>
    </div>
  )
}
